import { Button } from 'antd';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useBasePath } from '../../../components/NavigatePath';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs'

function ViewBlog() {
    const [backgroundImage, setBackgroundImage] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();
    const data = location.state?.data;
    const basePath = useBasePath();
    const userType = useSelector((state) => state.user?.user?.roleDetails?.id);
    console.log(data)
    const handleEditDetails = () => {
        navigate(`/${basePath}/blog/EditBlog/${data.id}`, { state: { data: data } });
    };

    useEffect(() => {
        if (data?.image) {
            setBackgroundImage(data.image);
        }
    }, [data]);


    return (
        <div className="bg-white p-8 rounded flex flex-col space-y-5">
            <div
                className="flex justify-center items-center min-h-96 bg-cover bg-center bg-no-repeat rounded-sm"
                style={{
                    backgroundImage: backgroundImage ? `url(${backgroundImage})` : "none",
                    backgroundColor: !backgroundImage ? "#F7F8FF" : "transparent",
                }}
            >
                {!backgroundImage && (
                    <p className="text-gray-500">No image available</p>
                )}
            </div>
            <div className="space-y-4">
                <div>
                    <p className='text-3xl	font-semibold	'>{data?.title || "No title provided"}</p>
                </div>
                <div className='bg-[#F7F8FF] py-1 rounded-xl w-fit px-6'>
                    <p className='text-[#3371EB] text-xl font-normal'>{data?.categoryDetails.name || "No category selected"}</p>
                </div>

                <div>
                    <p className="text-base font-normal">{data?.description || "No content available"}</p>
                </div>
                <div>
                    <p className="text-sm font-normal">{dayjs(data.createdAt).format("D MMM YYYY") || "No Date available"}</p>
                </div>
            </div>
            {userType ? null :
                <div className="flex flex-row justify-end space-x-5">
                    <Button
                        className="px-10 py-5 border-[#C0D3F9] text-[#295ABC]"
                        onClick={handleEditDetails}
                    >
                        Edit
                    </Button>
                    <Button
                        className="px-10 py-5 bg-[#E8FAE9] border-none"
                        style={{
                            backgroundColor: "#E8FAE9",
                            boxShadow: "none",
                            color: "inherit",
                        }}
                    >
                        <img src="/assets/images/repeat.svg" alt="Repeat Icon" />
                    </Button>

                </div>
            }
        </div>
    );
}

export default ViewBlog;
